
import { call, put, takeEvery } from 'redux-saga/effects';
import { message } from 'antd';
import packages from '../Actions/packages';
import { getPackagesRequest } from '../Api/Packages';
import { startLoading, stopLoading } from '../LoadingHelper';
const { types, actions } = packages;
const { setPackagesData } = actions;

export function* getPackages() {
    const loadingId = yield call(startLoading, 'licenseLoading');
    try {
        const response = yield call(getPackagesRequest);
        if(response && response.status === 'success' && response.data) {
            let res = response.data.map(item => {
                let newItem = JSON.parse(item.package);
                newItem.isVisible = item.isVisible;
                return newItem;
            });
            yield put(setPackagesData(res));
        } else {
            message.error('Ocurrió un error al obtener la información de los paquetes', 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* packagesSaga() {
    yield takeEvery(types.GET_PACKAGES_DATA, getPackages);
};